export const navigation = {
  userShop: [
    {
      id: 1,
      routeName: "landingPage1",
      text: "Inicio",
      count: true,
      subItem: [],
    },
    {
      id: 2,
      routeName: "GetToKnowTheClub2",
      text: "Conoce el club",
      count: true,
      subItem: []
    },
    {
      id: 3,
      routeName: "listOfAlliancesCategories2",
      text: "Alianzas",
      count: true,
      subItem: []
    }
  ],
  userShop2: [
    {
      id: 1,
      routeName: "profileUser",
      text: "Hola ",
      count: true,
      name: true,
      subItem: [],
    },
    {
      id: 2,
      routeName: "userCard",
      text: "",
      count: true,
      icon: true,
      subItem: [],
    }
  ],
  userLibricator: [
    {
      id: 1,
      routeName: "landingPage1",
      text: "Inicio",
      count: true,
      subItem: [],
    },
    {
      id: 2,
      routeName: "GetToKnowTheClub2",
      text: "Conoce el club",
      count: true,
      subItem: []
    },
    {
      id: 3,
      routeName: "listOfAlliancesCategories2",
      text: "Alianzas",
      count: true,
      subItem: []
    }
  ],
  userLibricator2: [
    {
      id: 1,
      routeName: "lubricatorProfile",
      text: "Hola ",
      count: true,
      name: true,
      subItem: [],
    },
    {
      id: 2,
      routeName: "userCard",
      text: "",
      count: true,
      icon: true,
      subItem: [],
    }
  ],
  userComercial: [
    {
      id: 1,
      routeName: "pointsOfSale",
      text: "Puntos de venta",
      subItem: [],
    },
    {
      id: 2,
      routeName: "dashboardDistributor",
      text: "Dashboard",
      count: true,
      // name: true,
      subItem: [
        {
          id: 1,
          routeName: "dashBiker",
          text: "Moteros",
        },
        {
          id: 2,
          routeName: "dashLub",
          text: "Lubricadores",
        },
        {
          id: 3,
          routeName: "distCampaign",
          text: "Campañas",
        },
      ],
      // style: {
      //   color: "#dc3545",
      //   margin: "0px 10px"
      // }
    },
    {
      id: 3,
      routeName: "comercialProfile",
      text: "Hola ",
      count: true,
      name: true,
      subItem: [],
    }
  ],
  userAdmin: [
    {
      id: 1,
      routeName: "adminCrm",
      text: "CRM Havoline",
      count: true,
      name: false,
      subItem: [],
    },
    {
      id: 2,
      routeName: "adminL",
      text: "Lubricadores",
      count: true,
      name: false,
      subItem: [],
    },
    {
      id: 3,
      routeName: "listPromo",
      text: "Bonos",
      count: true,
      name: false,
      subItem: [
        {
          id: 1,
          routeName: "promotions",
          text: "Promoción",
        }
      ],
    },
    {
      id: 4,
      routeName: "adminQuestion1",
      text: "Gestionar",
      count: true,
      name: true,
      subItem: [
        {
          id: 1,
          routeName: "adminQuestion1",
          text: "Preguntas frecuentes",
        },
        {
          id: 2,
          routeName: "adminBanner1",
          text: "Banner",
        },
        {
          id: 3,
          routeName: "adminAlianzas",
          text: "Alianzas",
        },
        {
          id: 4,
          routeName: "adminDocuments1",
          text: "Documentos",
        },
        {
          id: 5,
          routeName: "adminProducts",
          text: "Productos",
        },
        {
          id: 6,
          routeName: "adminHistory",
          text: "Historial",
        },
        {
          id: 7,
          routeName: "updateDataOrRegister",
          text: "Links",
        },
        {
          id: 8,
          routeName: "listHavoblog",
          text: "Havoblog",
        },
        {
          id: 9,
          routeName: "listProducts",
          text: "Sección Productos",
        },
        {
          id: 10,
          routeName: "listPOS",
          text: "Puntos de venta",
        }
      ],
    },
    {
      id: 5,
      routeName: "listUser",
      text: "Usuarios",
      count: true,
      name: false,
      subItem: [],
    }
  ],
  userAdminCrm: [
    {
      id: 1,
      routeName: "adminCrm",
      text: "CRM Havoline",
      count: true,
      name: false,
      subItem: [],
      style: {
        margin: "0px 20px"
      }
    }
  ],
  userPointOfSale: [
    {
      id: 1,
      routeName: "pointOfsaleProfile",
      text: "Hola ",
      count: true,
      name: true,
      subItem: [],
    },
    {
      id: 2,
      routeName: "userCard",
      text: "",
      count: true,
      icon: true,
      subItem: [],
    }
  ],
};